/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: supervision-webapp-contrib
 * Version: 7.1.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
(function () {
    "use strict";
    // Plier / déplier les block résultats
    var plierdeplier = function (actionButton) {
        if (!actionButton.className) {
            actionButton = this;
        }
        var detailsElement = actionButton.parentElement.parentElement.querySelector(".js-detailResult");
        if (actionButton.className.startsWith('plier')) {
            detailsElement.className = 'js-detailResult masquer';
            actionButton.className = 'deplier js-result_action_openclose';
            actionButton.textContent = LOCALE_BO.open;
        } else {
            detailsElement.className = 'js-detailResult col';
            actionButton.className = 'plier js-result_action_openclose';
            actionButton.textContent = LOCALE_BO.close;
        }
    };
    var defineOnClick = function (className, actionFunction) {
        var actionListButton = document.querySelectorAll(className);
        for (var i = 0; i < actionListButton.length; i++) {
            actionListButton[i].addEventListener("click", actionFunction, false);
        }
    };
    document.addEventListener("DOMContentLoaded", function () {
        // Définition du onClick
        defineOnClick('.js-result_action_openclose', plierdeplier);
        var actionListButton = document.querySelectorAll('.js-result_action_openclose');
        if (actionListButton.length > 1) {
            for (var i = 0; i < actionListButton.length; i++) {
                plierdeplier(actionListButton[i]);
            }
        }
    });
})();